import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import { Link } from 'react-router-dom';

import aboutImg from '../../assets/img/about/about-3.png';

const About = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(!isOpen);

  return (
    <div className="about-3__area about-3__space about-3__plr p-relative">
      <ModalVideo
        channel="youtube"
        isOpen={isOpen}
        videoId="PO_fBTkoznc"
        onClose={() => {
          openModal();
        }}
      />
      <div className="container-fluid">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 col-md-12 mb-70 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <div className="about-3__item">
              <img src={aboutImg} alt="" />
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 col-md-12 mb-70 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="about-3__item">
              <div className="about-3__section-title pb-10">
                <h4
                className="section-subtitle char-anim wow animate__fadeInUp align-items-center"
                data-wow-duration="1.1s"
                data-wow-delay=".3s"
              >
               <b> Who We Are </b>
              </h4>
                <h3 className="section-title char-anim">
                  We Provide Smart IT Solutions  <br />
                  to Help Businesses Grow.
                </h3>
              </div>
              <div className="about-3__content">
                <div className="about-3__text pb-7">
                  <p className="char-anim-2">
                    At TGVC Technologies, we are more than just an IT and technology services startup, we are your partners in innovation. With a dedicated team of experts, we offer a comprehensive suite of services designed to empower businesses, organizations, and individuals alike.{' '}
                  </p>
                </div>
                <div
                  className="about-3__content-list wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".7s"
                >
                  <ul>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Scalable Cloud Solutions</span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Full-Stack App Development</span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Smart Automation Tools</span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>24/7 Tech Support</span>
                    </li>
                  </ul>
                  <div className="about-3__text">
                    <p>
                      We build technology that transforms businesses. From custom software development to cloud integration and automation, we help ambitious teams streamline operations, spark innovation, and scale faster—backed by expert support every step of the way.{' '}
                    </p>
                  </div>
                </div>
                <div className="about-3__button-box d-flex align-items-center">
                  <div
                    className="about-3__button pr-40 wow animate__fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".9s"
                  >
                    <Link
                      className="main-btn-sm tp-btn-hover alt-color"
                      to="/about-us"
                    >
                      <span>About More</span>
                      <b></b>
                    </Link>
                  </div>
                  {/*<div
                    className="about-3__button d-flex align-items-center wow animate__fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay="1.1s"
                  >
                    <div className="about-3__video">
                      <Link
                        className="popup-video"
                        to="#"
                        onClick={() => {
                          openModal();
                        }}
                      >
                        <i className="fas fa-play"></i>
                      </Link>
                    </div>
                    <div className="about-3__video-text">
                      <Link
                        to="#"
                        onClick={() => {
                          openModal();
                        }}
                      >
                        <span>Watch Video</span>
                      </Link>
                    </div>
                  </div>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
